<template>
  <div class="controlItemWrapper" :class="control.className" :data-control-name="control.name">
    <div class="controlItem row" :id="control.name" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}">
          {{control.label}}
        </label>
      </div>
      <div class="col-md-8 input-group">
        <multiselect
          v-model="users"
          :options="usersSelect"
          track-by="value"
          label="text"
          selectedLabel=""
          :searchable="true"
          placeholder="Select one"
          :allow-empty="true"
          :multiple="true"
          :disabled="control.readonly"
          openDirection="bottom"
        />
      </div>
    </div>
    <div class="controlItem row" :id="control.name" v-else>
      <div class="form-group col-md-12">
        <label :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}">
          {{control.label}}
        </label>
        <div>
          <multiselect
            v-model="users"
            :options="usersSelect"
            track-by="value"
            label="text"
            selectedLabel=""
            :searchable="true"
            placeholder="Select one"
            :allow-empty="true"
            :multiple="true"
            :disabled="control.readonly"
            openDirection="bottom"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: ['control', 'labelPosition'],
  data () {
    return {
      users: []
    }
  },
  computed: {
    ...mapState ([
      'userList'
    ]),
    usersSelect () {
      const userList = [];

      for (let user of this.userList) {
        userList.push({ text: user.email || user.uid, value: user.uid });
      }

      return userList;
    }
  }
};
</script>
